import { useCrud } from '@next-qr/lib-ui/hooks';
import type { CrudListOptions, CrudGetOptions } from '@next-qr/lib-ui/hooks/useCrud';
import { orgApi } from './api';

export interface Organization {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  website: string | null;
  logo_url: string | null;
}

const crud = useCrud<Organization>(orgApi);

export const useOrgList   = (options?: CrudListOptions) => crud.useList({ ...options, subscriptionFn: orgApi.subscribe });
export const useOrg       = (id: string | number, options?: CrudGetOptions) => crud.useGet(id, { ...options, subscriptionFn: orgApi.subscribe });
export const useCreateOrg = (options?: Parameters<typeof crud.useCreate>[0]) => crud.useCreate(options);
export const useUpdateOrg = (options?: Parameters<typeof crud.useUpdate>[0]) => crud.useUpdate(options);
export const useRemoveOrg = (options?: Parameters<typeof crud.useRemove>[0]) => crud.useRemove(options);
